import {$t} from "@/i18n";
import { actions as appActions } from "@/store/modules/app";

class ErrorDialog {
    constructor() {
        this.title = null;
        this.content = null;
        this.show = false;
        this.closeCallback = null
        this.buttonText = null
    }

    getTitle() {
        return this.title
    }

    getContent() {
        return this.content
    }

    getButtonText() {
        return this.buttonText
    }

    isVisible() {
        return this.show
    }

    onCloseClick() {
        this.closeCallback()
    }

    close() {
        this.show = false;
    }

    getErrorFromStatusCode(statusCode) {
        if (statusCode === 400) {
            return $t("Something went wrong");
        } else if (statusCode === 401) {
            return $t("User authentication needed");
        } else if (statusCode === 403) {
            return $t("Invalid rights");
        } else if (statusCode === 404) {
            return $t("The object cannot be found");
        } else if (statusCode === 413) {
            return $t('Content too large')
        } else if (statusCode === 500) {
            return $t("An unknown error occurred");
        } else if (statusCode === 501) {
            return $t("The action requested cannot be performed");
        }

        return null
    }

    showError(error) {
        this.title = null
        this.content = null
        this.closeCallback = null
        this.buttonText = null

        if(error.response?.status === 502) {
            appActions.showGlobalConnectionLost()
            return
        }

        console.error('UI SHOW ERROR', error) // DO NOT REMOVE
        this.closeCallback = this.close
        this.buttonText = $t('Close')

        let responseData

        if (error instanceof XMLHttpRequest) {
            try {
                responseData = JSON.parse(error.response)
            } catch (e) {
                this.title = this.getErrorFromStatusCode(error.status);
                //this.content = error.statusText;
                this.show = true;
                return;
            }
        } else {
            if (error.response && error.response.data) {
                responseData = error.response.data
            }
        }

        if (responseData) {
            if (responseData.error_type === "braintree_transaction") {
                this.title = responseData.error_title;
                this.content = responseData.error_message;
                this.show = true;
                return;
            }

            if (responseData.error_type === "form_validation" || responseData.error_type === "partial_failure") {
                let errs_array = responseData.errors.map(err => {
                    if (err.dialog_error_message) {
                        return err.dialog_error_message
                    } else {
                        return err.error_message
                    }
                });
                // Explicitly show form validation errors in a global dialog
                this.title = responseData.title;
                this.content = errs_array.join("<br>");
                if (responseData.content) {
                    this.content += "<br><br>" + responseData.content
                }
                this.show = true;
                return;
            }

            if (responseData.error_type === "redirection_required") {
                if (1) {
                    // Try to authorize
                    return window.location = responseData.redirect_to
                } else {
                    this.title = responseData.content
                    this.buttonText = $t("Go")
                    this.closeCallback = () => {
                        window.location = responseData.redirect_to
                    }
                    this.show = true;
                    return
                }
            }

            if (responseData.vendor) {
                this.title = responseData.errors[0]
                this.show = true
                return
            }
        }

        if (error.response !== undefined) {
            console.log(typeof error)
            console.log(responseData)
            this.title = this.getErrorFromStatusCode(error.response.status)

            this.content = error.response.statusText;

            // Fallback, that shouldn't exist if this whole thing wasn't so messy
            if(!this.content && responseData && responseData.status_text) this.content = responseData.status_text

            this.show = true;
            return;
        }

        if (typeof error === "string") {
            this.title = error;
            this.content = "";
            this.show = true;
            return;
        }

        if (error.callback) {
            this.closeCallback = error.callback
        }

        if (error.button_text) {
            this.buttonText = error.button_text
        }

        this.title = error.message;
        this.content = error.details ? error.details : null;
        this.show = true;
    };
}

let dialog = new ErrorDialog()

export default dialog